import { Component, OnInit } from '@angular/core';
import { ModalController, NavParams } from '@ionic/angular';

@Component({
  selector: 'app-modal-confirmation',
  templateUrl: './modal-confirmation.component.html',
  styleUrls: ['./modal-confirmation.component.scss'],
})
export class ModalConfirmationComponent implements OnInit {

  confirmationText: string = "¿Estás seguro de que deseas actualizar este permiso?";

  constructor(private modalController: ModalController, navParams: NavParams) {
    let confirmationText = navParams.get('confirmationText');
    if (confirmationText) this.confirmationText = confirmationText;
  }

  ngOnInit() { }
  closeModal(accepted: boolean) {
    this.modalController.dismiss({
      accepted: accepted
    });
  }
}
